import { default as _91_46_46_46slug_93FWKctUgJPuMeta } from "/home/forge/oase-aej.de/releases/81992485/client/pages/[...slug].vue?macro=true";
import { default as indexSrCRYLB6q1Meta } from "/home/forge/oase-aej.de/releases/81992485/client/pages/auth/index.vue?macro=true";
import { default as indexHu7K5LOaSbMeta } from "/home/forge/oase-aej.de/releases/81992485/client/pages/auth/social/[organisation]/[provider]/index.vue?macro=true";
import { default as datenschutzjBo3tFyfpKMeta } from "/home/forge/oase-aej.de/releases/81992485/client/pages/datenschutz.vue?macro=true";
import { default as datenverarbeitung3B46A3N5k5Meta } from "/home/forge/oase-aej.de/releases/81992485/client/pages/datenverarbeitung.vue?macro=true";
import { default as _91id_93z6IeJ3vZ2ZMeta } from "/home/forge/oase-aej.de/releases/81992485/client/pages/formProcess/[id].vue?macro=true";
import { default as _91id_93X5YQfyPmHAMeta } from "/home/forge/oase-aej.de/releases/81992485/client/pages/formProcess/success/[id].vue?macro=true";
import { default as impressumkcAFhXPnzqMeta } from "/home/forge/oase-aej.de/releases/81992485/client/pages/impressum.vue?macro=true";
import { default as indexzD3ywQBsoLMeta } from "/home/forge/oase-aej.de/releases/81992485/client/pages/index.vue?macro=true";
import { default as _91slug_93DxeeGGJn4cMeta } from "/home/forge/oase-aej.de/releases/81992485/client/pages/news/[slug].vue?macro=true";
import { default as organisationsUQ3i1f0xeRMeta } from "/home/forge/oase-aej.de/releases/81992485/client/pages/organisations.vue?macro=true";
import { default as indexEXCcKRCgYJMeta } from "/home/forge/oase-aej.de/releases/81992485/client/pages/processes/index.vue?macro=true";
import { default as dungeon2GXUVMXwdnMeta } from "/home/forge/oase-aej.de/releases/81992485/client/pages/secret/index/dungeon.vue?macro=true";
import { default as inputsq1S3pu998tMeta } from "/home/forge/oase-aej.de/releases/81992485/client/pages/secret/index/inputs.vue?macro=true";
import { default as indexiwuEnCnA0WMeta } from "/home/forge/oase-aej.de/releases/81992485/client/pages/secret/index.vue?macro=true";
import { default as indexUiwbhdaMOQMeta } from "/home/forge/oase-aej.de/releases/81992485/client/pages/service/basicData/categories/index.vue?macro=true";
import { default as formBaseData2fSwPAxTAdMeta } from "/home/forge/oase-aej.de/releases/81992485/client/pages/service/basicData/forms/[id]/formBaseData.vue?macro=true";
import { default as formClassMCbAbziJbiMeta } from "/home/forge/oase-aej.de/releases/81992485/client/pages/service/basicData/forms/[id]/formClass.vue?macro=true";
import { default as _91id_93ugUHkfhgLLMeta } from "/home/forge/oase-aej.de/releases/81992485/client/pages/service/basicData/forms/[id].vue?macro=true";
import { default as indexSeiy279GkyMeta } from "/home/forge/oase-aej.de/releases/81992485/client/pages/service/basicData/forms/index.vue?macro=true";
import { default as fundingProgramBaseDatatw2C2Pc2KiMeta } from "/home/forge/oase-aej.de/releases/81992485/client/pages/service/basicData/fundingPrograms/[id]/fundingProgramBaseData.vue?macro=true";
import { default as fundingProgramReportsElftXBnhGYMeta } from "/home/forge/oase-aej.de/releases/81992485/client/pages/service/basicData/fundingPrograms/[id]/fundingProgramReports.vue?macro=true";
import { default as fundingProgramRights808C3eQeYTMeta } from "/home/forge/oase-aej.de/releases/81992485/client/pages/service/basicData/fundingPrograms/[id]/fundingProgramRights.vue?macro=true";
import { default as _91id_93IE076rDIbrMeta } from "/home/forge/oase-aej.de/releases/81992485/client/pages/service/basicData/fundingPrograms/[id].vue?macro=true";
import { default as indexWlFQg0GuKAMeta } from "/home/forge/oase-aej.de/releases/81992485/client/pages/service/basicData/fundingPrograms/index.vue?macro=true";
import { default as mailActivitiesYNdI0f9kz4Meta } from "/home/forge/oase-aej.de/releases/81992485/client/pages/service/basicData/mails/[id]/mailActivities.vue?macro=true";
import { default as mailBaseDatamc02E1L48jMeta } from "/home/forge/oase-aej.de/releases/81992485/client/pages/service/basicData/mails/[id]/mailBaseData.vue?macro=true";
import { default as _91id_93qcGfEh0l9CMeta } from "/home/forge/oase-aej.de/releases/81992485/client/pages/service/basicData/mails/[id].vue?macro=true";
import { default as indexOB7Ax4svIRMeta } from "/home/forge/oase-aej.de/releases/81992485/client/pages/service/basicData/mails/index.vue?macro=true";
import { default as mailTemplateActivitiesOsyV4lgWnTMeta } from "/home/forge/oase-aej.de/releases/81992485/client/pages/service/basicData/mailTemplates/[id]/mailTemplateActivities.vue?macro=true";
import { default as mailTemplateBaseDataM9AcMgTXfQMeta } from "/home/forge/oase-aej.de/releases/81992485/client/pages/service/basicData/mailTemplates/[id]/mailTemplateBaseData.vue?macro=true";
import { default as _91id_936VY43VObYRMeta } from "/home/forge/oase-aej.de/releases/81992485/client/pages/service/basicData/mailTemplates/[id].vue?macro=true";
import { default as indexGIkq4pXY4PMeta } from "/home/forge/oase-aej.de/releases/81992485/client/pages/service/basicData/mailTemplates/index.vue?macro=true";
import { default as roleBaseDataP5Tag7OhhtMeta } from "/home/forge/oase-aej.de/releases/81992485/client/pages/service/basicData/roles/[name]/roleBaseData.vue?macro=true";
import { default as _91name_93J6LIJYMF2RMeta } from "/home/forge/oase-aej.de/releases/81992485/client/pages/service/basicData/roles/[name].vue?macro=true";
import { default as index4tb8HVgGmlMeta } from "/home/forge/oase-aej.de/releases/81992485/client/pages/service/basicData/roles/index.vue?macro=true";
import { default as statusActivitiesxWs3OFBay7Meta } from "/home/forge/oase-aej.de/releases/81992485/client/pages/service/basicData/statuses/[id]/statusActivities.vue?macro=true";
import { default as statusBaseDataR8HK2W5Tm0Meta } from "/home/forge/oase-aej.de/releases/81992485/client/pages/service/basicData/statuses/[id]/statusBaseData.vue?macro=true";
import { default as statusNotificationsUoJrVnVAXcMeta } from "/home/forge/oase-aej.de/releases/81992485/client/pages/service/basicData/statuses/[id]/statusNotifications.vue?macro=true";
import { default as _91id_9341qUyoSSqbMeta } from "/home/forge/oase-aej.de/releases/81992485/client/pages/service/basicData/statuses/[id].vue?macro=true";
import { default as indexOV3mV0IlPsMeta } from "/home/forge/oase-aej.de/releases/81992485/client/pages/service/basicData/statuses/index.vue?macro=true";
import { default as yearBaseDataO2HWDBeZDuMeta } from "/home/forge/oase-aej.de/releases/81992485/client/pages/service/basicData/years/[id]/yearBaseData.vue?macro=true";
import { default as yearDatatPR1ZIVDVfMeta } from "/home/forge/oase-aej.de/releases/81992485/client/pages/service/basicData/years/[id]/yearData.vue?macro=true";
import { default as yearInterviewsNLYNWKiKrtMeta } from "/home/forge/oase-aej.de/releases/81992485/client/pages/service/basicData/years/[id]/yearInterviews.vue?macro=true";
import { default as _91id_93wRM2pgrgUtMeta } from "/home/forge/oase-aej.de/releases/81992485/client/pages/service/basicData/years/[id].vue?macro=true";
import { default as index5Wp4lMS26pMeta } from "/home/forge/oase-aej.de/releases/81992485/client/pages/service/basicData/years/index.vue?macro=true";
import { default as basicDataYXrgq7NgRQMeta } from "/home/forge/oase-aej.de/releases/81992485/client/pages/service/basicData.vue?macro=true";
import { default as _91id_93bz8KNoA79IMeta } from "/home/forge/oase-aej.de/releases/81992485/client/pages/service/formProcesses/[id].vue?macro=true";
import { default as indexc7SuDh6b50Meta } from "/home/forge/oase-aej.de/releases/81992485/client/pages/service/index.vue?macro=true";
import { default as paymentRunActivitiesdC58aquk3NMeta } from "/home/forge/oase-aej.de/releases/81992485/client/pages/service/payments/paymentRuns/[id]/paymentRunActivities.vue?macro=true";
import { default as paymentRunBaseData3p36L7FAWBMeta } from "/home/forge/oase-aej.de/releases/81992485/client/pages/service/payments/paymentRuns/[id]/paymentRunBaseData.vue?macro=true";
import { default as paymentRunPaymentsdBuMQKXEwNMeta } from "/home/forge/oase-aej.de/releases/81992485/client/pages/service/payments/paymentRuns/[id]/paymentRunPayments.vue?macro=true";
import { default as _91id_934SBnW8gLX4Meta } from "/home/forge/oase-aej.de/releases/81992485/client/pages/service/payments/paymentRuns/[id].vue?macro=true";
import { default as index6hMOLjvZd9Meta } from "/home/forge/oase-aej.de/releases/81992485/client/pages/service/payments/paymentRuns/index.vue?macro=true";
import { default as payments5VsYy1KCBJMeta } from "/home/forge/oase-aej.de/releases/81992485/client/pages/service/payments.vue?macro=true";
import { default as processActivitiesGrkCCqDQvlMeta } from "/home/forge/oase-aej.de/releases/81992485/client/pages/service/processes/[id]/processActivities.vue?macro=true";
import { default as processBaseDataRjJFHaYJULMeta } from "/home/forge/oase-aej.de/releases/81992485/client/pages/service/processes/[id]/processBaseData.vue?macro=true";
import { default as _91id_93wLXkDwCpI6Meta } from "/home/forge/oase-aej.de/releases/81992485/client/pages/service/processes/[id].vue?macro=true";
import { default as indexa81fTnixu6Meta } from "/home/forge/oase-aej.de/releases/81992485/client/pages/service/processes/index.vue?macro=true";
import { default as massApprovalCGFMcYihRaMeta } from "/home/forge/oase-aej.de/releases/81992485/client/pages/service/processes/massApproval.vue?macro=true";
import { default as _91id_93yqONJDo0pGMeta } from "/home/forge/oase-aej.de/releases/81992485/client/pages/service/settings/loginProviders/[id].vue?macro=true";
import { default as indexZwVeSXtkjgMeta } from "/home/forge/oase-aej.de/releases/81992485/client/pages/service/settings/loginProviders/index.vue?macro=true";
import { default as loginProvidersM70QbXmTT8Meta } from "/home/forge/oase-aej.de/releases/81992485/client/pages/service/settings/loginProviders.vue?macro=true";
import { default as organisationActivitiesYdHcQfNKdHMeta } from "/home/forge/oase-aej.de/releases/81992485/client/pages/service/settings/organisations/[id]/organisationActivities.vue?macro=true";
import { default as organisationAssociationSettings2oA3KLNTylMeta } from "/home/forge/oase-aej.de/releases/81992485/client/pages/service/settings/organisations/[id]/organisationAssociationSettings.vue?macro=true";
import { default as organisationBaseData1JNJy8NTsIMeta } from "/home/forge/oase-aej.de/releases/81992485/client/pages/service/settings/organisations/[id]/organisationBaseData.vue?macro=true";
import { default as organisationCategoriesBCIK6Gd9V4Meta } from "/home/forge/oase-aej.de/releases/81992485/client/pages/service/settings/organisations/[id]/organisationCategories.vue?macro=true";
import { default as organisationProtectionConceptkltHAd9mAsMeta } from "/home/forge/oase-aej.de/releases/81992485/client/pages/service/settings/organisations/[id]/organisationProtectionConcept.vue?macro=true";
import { default as organisationStemSheetgnQ4UtmtEdMeta } from "/home/forge/oase-aej.de/releases/81992485/client/pages/service/settings/organisations/[id]/organisationStemSheet.vue?macro=true";
import { default as organisationUsersn7T6m34ABDMeta } from "/home/forge/oase-aej.de/releases/81992485/client/pages/service/settings/organisations/[id]/organisationUsers.vue?macro=true";
import { default as _91id_9360oMDLXdVjMeta } from "/home/forge/oase-aej.de/releases/81992485/client/pages/service/settings/organisations/[id].vue?macro=true";
import { default as index7XymXj0lahMeta } from "/home/forge/oase-aej.de/releases/81992485/client/pages/service/settings/organisations/index.vue?macro=true";
import { default as organisations1TgKB3DhfIMeta } from "/home/forge/oase-aej.de/releases/81992485/client/pages/service/settings/organisations.vue?macro=true";
import { default as userActivitiesKnKqIndOk2Meta } from "/home/forge/oase-aej.de/releases/81992485/client/pages/service/settings/users/[id]/userActivities.vue?macro=true";
import { default as userBaseData5jFOHQz5G6Meta } from "/home/forge/oase-aej.de/releases/81992485/client/pages/service/settings/users/[id]/userBaseData.vue?macro=true";
import { default as userFiltersSly3yjmZZdMeta } from "/home/forge/oase-aej.de/releases/81992485/client/pages/service/settings/users/[id]/userFilters.vue?macro=true";
import { default as userSignature45dCzVulYAMeta } from "/home/forge/oase-aej.de/releases/81992485/client/pages/service/settings/users/[id]/userSignature.vue?macro=true";
import { default as _91id_93bp3GGznALIMeta } from "/home/forge/oase-aej.de/releases/81992485/client/pages/service/settings/users/[id].vue?macro=true";
import { default as indexx0JmFkf1wwMeta } from "/home/forge/oase-aej.de/releases/81992485/client/pages/service/settings/users/index.vue?macro=true";
import { default as usersx8z5ak7V4gMeta } from "/home/forge/oase-aej.de/releases/81992485/client/pages/service/settings/users.vue?macro=true";
import { default as settingsuC5F9BVtKoMeta } from "/home/forge/oase-aej.de/releases/81992485/client/pages/service/settings.vue?macro=true";
import { default as servicey3frGyIMWJMeta } from "/home/forge/oase-aej.de/releases/81992485/client/pages/service.vue?macro=true";
import { default as indexZwSR7NaHVaMeta } from "/home/forge/oase-aej.de/releases/81992485/client/pages/settings/childOrganisations/index.vue?macro=true";
import { default as language06F7RqGuBAMeta } from "/home/forge/oase-aej.de/releases/81992485/client/pages/settings/language.vue?macro=true";
import { default as organisationBaseDataaYLzf2HubjMeta } from "/home/forge/oase-aej.de/releases/81992485/client/pages/settings/organisations/[id]/organisationBaseData.vue?macro=true";
import { default as organisationCategorieshxQtUmTzC8Meta } from "/home/forge/oase-aej.de/releases/81992485/client/pages/settings/organisations/[id]/organisationCategories.vue?macro=true";
import { default as organisationProtectionConceptlRmlhdCGJYMeta } from "/home/forge/oase-aej.de/releases/81992485/client/pages/settings/organisations/[id]/organisationProtectionConcept.vue?macro=true";
import { default as organisationStemSheetBwzSiKTsDeMeta } from "/home/forge/oase-aej.de/releases/81992485/client/pages/settings/organisations/[id]/organisationStemSheet.vue?macro=true";
import { default as organisationUsersHMFg98ElYCMeta } from "/home/forge/oase-aej.de/releases/81992485/client/pages/settings/organisations/[id]/organisationUsers.vue?macro=true";
import { default as _91id_93un3Sg0B3YbMeta } from "/home/forge/oase-aej.de/releases/81992485/client/pages/settings/organisations/[id].vue?macro=true";
import { default as userBaseDataWlnzmnxL5LMeta } from "/home/forge/oase-aej.de/releases/81992485/client/pages/settings/users/[id]/userBaseData.vue?macro=true";
import { default as userSignatureS856krWyIiMeta } from "/home/forge/oase-aej.de/releases/81992485/client/pages/settings/users/[id]/userSignature.vue?macro=true";
import { default as _91id_937ZDzhbfQmYMeta } from "/home/forge/oase-aej.de/releases/81992485/client/pages/settings/users/[id].vue?macro=true";
import { default as settings4iUyez6raCMeta } from "/home/forge/oase-aej.de/releases/81992485/client/pages/settings.vue?macro=true";
import { default as signature8yuDC8QLHlMeta } from "/home/forge/oase-aej.de/releases/81992485/client/pages/signature.vue?macro=true";
export default [
  {
    name: "slug",
    path: "/:slug(.*)*",
    meta: _91_46_46_46slug_93FWKctUgJPuMeta || {},
    component: () => import("/home/forge/oase-aej.de/releases/81992485/client/pages/[...slug].vue")
  },
  {
    name: "auth",
    path: "/auth",
    meta: indexSrCRYLB6q1Meta || {},
    component: () => import("/home/forge/oase-aej.de/releases/81992485/client/pages/auth/index.vue")
  },
  {
    name: "auth-social-organisation-provider",
    path: "/auth/social/:organisation()/:provider()",
    meta: indexHu7K5LOaSbMeta || {},
    component: () => import("/home/forge/oase-aej.de/releases/81992485/client/pages/auth/social/[organisation]/[provider]/index.vue")
  },
  {
    name: "datenschutz",
    path: "/datenschutz",
    component: () => import("/home/forge/oase-aej.de/releases/81992485/client/pages/datenschutz.vue")
  },
  {
    name: "datenverarbeitung",
    path: "/datenverarbeitung",
    component: () => import("/home/forge/oase-aej.de/releases/81992485/client/pages/datenverarbeitung.vue")
  },
  {
    name: "formProcess-id",
    path: "/formProcess/:id()",
    meta: _91id_93z6IeJ3vZ2ZMeta || {},
    component: () => import("/home/forge/oase-aej.de/releases/81992485/client/pages/formProcess/[id].vue")
  },
  {
    name: "formProcess-success-id",
    path: "/formProcess/success/:id()",
    meta: _91id_93X5YQfyPmHAMeta || {},
    component: () => import("/home/forge/oase-aej.de/releases/81992485/client/pages/formProcess/success/[id].vue")
  },
  {
    name: "impressum",
    path: "/impressum",
    component: () => import("/home/forge/oase-aej.de/releases/81992485/client/pages/impressum.vue")
  },
  {
    name: "index",
    path: "/",
    meta: indexzD3ywQBsoLMeta || {},
    component: () => import("/home/forge/oase-aej.de/releases/81992485/client/pages/index.vue")
  },
  {
    name: "news-slug",
    path: "/news/:slug()",
    component: () => import("/home/forge/oase-aej.de/releases/81992485/client/pages/news/[slug].vue")
  },
  {
    name: "organisations",
    path: "/organisations",
    meta: organisationsUQ3i1f0xeRMeta || {},
    component: () => import("/home/forge/oase-aej.de/releases/81992485/client/pages/organisations.vue")
  },
  {
    name: "processes",
    path: "/processes",
    meta: indexEXCcKRCgYJMeta || {},
    component: () => import("/home/forge/oase-aej.de/releases/81992485/client/pages/processes/index.vue")
  },
  {
    name: "secret",
    path: "/secret",
    component: () => import("/home/forge/oase-aej.de/releases/81992485/client/pages/secret/index.vue"),
    children: [
  {
    name: "secret-index-dungeon",
    path: "dungeon",
    component: () => import("/home/forge/oase-aej.de/releases/81992485/client/pages/secret/index/dungeon.vue")
  },
  {
    name: "secret-index-inputs",
    path: "inputs",
    component: () => import("/home/forge/oase-aej.de/releases/81992485/client/pages/secret/index/inputs.vue")
  }
]
  },
  {
    name: servicey3frGyIMWJMeta?.name,
    path: "/service",
    meta: servicey3frGyIMWJMeta || {},
    component: () => import("/home/forge/oase-aej.de/releases/81992485/client/pages/service.vue"),
    children: [
  {
    name: "service-basicData",
    path: "basicData",
    meta: basicDataYXrgq7NgRQMeta || {},
    component: () => import("/home/forge/oase-aej.de/releases/81992485/client/pages/service/basicData.vue"),
    children: [
  {
    name: "service-basicData-categories",
    path: "categories",
    meta: indexUiwbhdaMOQMeta || {},
    component: () => import("/home/forge/oase-aej.de/releases/81992485/client/pages/service/basicData/categories/index.vue")
  },
  {
    name: "service-basicData-forms-id",
    path: "forms/:id()",
    meta: _91id_93ugUHkfhgLLMeta || {},
    component: () => import("/home/forge/oase-aej.de/releases/81992485/client/pages/service/basicData/forms/[id].vue"),
    children: [
  {
    name: "service-basicData-forms-id-formBaseData",
    path: "formBaseData",
    component: () => import("/home/forge/oase-aej.de/releases/81992485/client/pages/service/basicData/forms/[id]/formBaseData.vue")
  },
  {
    name: "service-basicData-forms-id-formClass",
    path: "formClass",
    component: () => import("/home/forge/oase-aej.de/releases/81992485/client/pages/service/basicData/forms/[id]/formClass.vue")
  }
]
  },
  {
    name: "service-basicData-forms",
    path: "forms",
    meta: indexSeiy279GkyMeta || {},
    component: () => import("/home/forge/oase-aej.de/releases/81992485/client/pages/service/basicData/forms/index.vue")
  },
  {
    name: "service-basicData-fundingPrograms-id",
    path: "fundingPrograms/:id()",
    meta: _91id_93IE076rDIbrMeta || {},
    component: () => import("/home/forge/oase-aej.de/releases/81992485/client/pages/service/basicData/fundingPrograms/[id].vue"),
    children: [
  {
    name: "service-basicData-fundingPrograms-id-fundingProgramBaseData",
    path: "fundingProgramBaseData",
    component: () => import("/home/forge/oase-aej.de/releases/81992485/client/pages/service/basicData/fundingPrograms/[id]/fundingProgramBaseData.vue")
  },
  {
    name: "service-basicData-fundingPrograms-id-fundingProgramReports",
    path: "fundingProgramReports",
    component: () => import("/home/forge/oase-aej.de/releases/81992485/client/pages/service/basicData/fundingPrograms/[id]/fundingProgramReports.vue")
  },
  {
    name: "service-basicData-fundingPrograms-id-fundingProgramRights",
    path: "fundingProgramRights",
    component: () => import("/home/forge/oase-aej.de/releases/81992485/client/pages/service/basicData/fundingPrograms/[id]/fundingProgramRights.vue")
  }
]
  },
  {
    name: "service-basicData-fundingPrograms",
    path: "fundingPrograms",
    meta: indexWlFQg0GuKAMeta || {},
    component: () => import("/home/forge/oase-aej.de/releases/81992485/client/pages/service/basicData/fundingPrograms/index.vue")
  },
  {
    name: "service-basicData-mails-id",
    path: "mails/:id()",
    meta: _91id_93qcGfEh0l9CMeta || {},
    component: () => import("/home/forge/oase-aej.de/releases/81992485/client/pages/service/basicData/mails/[id].vue"),
    children: [
  {
    name: "service-basicData-mails-id-mailActivities",
    path: "mailActivities",
    component: () => import("/home/forge/oase-aej.de/releases/81992485/client/pages/service/basicData/mails/[id]/mailActivities.vue")
  },
  {
    name: "service-basicData-mails-id-mailBaseData",
    path: "mailBaseData",
    component: () => import("/home/forge/oase-aej.de/releases/81992485/client/pages/service/basicData/mails/[id]/mailBaseData.vue")
  }
]
  },
  {
    name: "service-basicData-mails",
    path: "mails",
    meta: indexOB7Ax4svIRMeta || {},
    component: () => import("/home/forge/oase-aej.de/releases/81992485/client/pages/service/basicData/mails/index.vue")
  },
  {
    name: "service-basicData-mailTemplates-id",
    path: "mailTemplates/:id()",
    meta: _91id_936VY43VObYRMeta || {},
    component: () => import("/home/forge/oase-aej.de/releases/81992485/client/pages/service/basicData/mailTemplates/[id].vue"),
    children: [
  {
    name: "service-basicData-mailTemplates-id-mailTemplateActivities",
    path: "mailTemplateActivities",
    component: () => import("/home/forge/oase-aej.de/releases/81992485/client/pages/service/basicData/mailTemplates/[id]/mailTemplateActivities.vue")
  },
  {
    name: "service-basicData-mailTemplates-id-mailTemplateBaseData",
    path: "mailTemplateBaseData",
    component: () => import("/home/forge/oase-aej.de/releases/81992485/client/pages/service/basicData/mailTemplates/[id]/mailTemplateBaseData.vue")
  }
]
  },
  {
    name: "service-basicData-mailTemplates",
    path: "mailTemplates",
    meta: indexGIkq4pXY4PMeta || {},
    component: () => import("/home/forge/oase-aej.de/releases/81992485/client/pages/service/basicData/mailTemplates/index.vue")
  },
  {
    name: "service-basicData-roles-name",
    path: "roles/:name()",
    meta: _91name_93J6LIJYMF2RMeta || {},
    component: () => import("/home/forge/oase-aej.de/releases/81992485/client/pages/service/basicData/roles/[name].vue"),
    children: [
  {
    name: "service-basicData-roles-name-roleBaseData",
    path: "roleBaseData",
    component: () => import("/home/forge/oase-aej.de/releases/81992485/client/pages/service/basicData/roles/[name]/roleBaseData.vue")
  }
]
  },
  {
    name: "service-basicData-roles",
    path: "roles",
    meta: index4tb8HVgGmlMeta || {},
    component: () => import("/home/forge/oase-aej.de/releases/81992485/client/pages/service/basicData/roles/index.vue")
  },
  {
    name: "service-basicData-statuses-id",
    path: "statuses/:id()",
    meta: _91id_9341qUyoSSqbMeta || {},
    component: () => import("/home/forge/oase-aej.de/releases/81992485/client/pages/service/basicData/statuses/[id].vue"),
    children: [
  {
    name: "service-basicData-statuses-id-statusActivities",
    path: "statusActivities",
    component: () => import("/home/forge/oase-aej.de/releases/81992485/client/pages/service/basicData/statuses/[id]/statusActivities.vue")
  },
  {
    name: "service-basicData-statuses-id-statusBaseData",
    path: "statusBaseData",
    component: () => import("/home/forge/oase-aej.de/releases/81992485/client/pages/service/basicData/statuses/[id]/statusBaseData.vue")
  },
  {
    name: "service-basicData-statuses-id-statusNotifications",
    path: "statusNotifications",
    meta: statusNotificationsUoJrVnVAXcMeta || {},
    component: () => import("/home/forge/oase-aej.de/releases/81992485/client/pages/service/basicData/statuses/[id]/statusNotifications.vue")
  }
]
  },
  {
    name: "service-basicData-statuses",
    path: "statuses",
    meta: indexOV3mV0IlPsMeta || {},
    component: () => import("/home/forge/oase-aej.de/releases/81992485/client/pages/service/basicData/statuses/index.vue")
  },
  {
    name: "service-basicData-years-id",
    path: "years/:id()",
    meta: _91id_93wRM2pgrgUtMeta || {},
    component: () => import("/home/forge/oase-aej.de/releases/81992485/client/pages/service/basicData/years/[id].vue"),
    children: [
  {
    name: "service-basicData-years-id-yearBaseData",
    path: "yearBaseData",
    component: () => import("/home/forge/oase-aej.de/releases/81992485/client/pages/service/basicData/years/[id]/yearBaseData.vue")
  },
  {
    name: "service-basicData-years-id-yearData",
    path: "yearData",
    component: () => import("/home/forge/oase-aej.de/releases/81992485/client/pages/service/basicData/years/[id]/yearData.vue")
  },
  {
    name: "service-basicData-years-id-yearInterviews",
    path: "yearInterviews",
    component: () => import("/home/forge/oase-aej.de/releases/81992485/client/pages/service/basicData/years/[id]/yearInterviews.vue")
  }
]
  },
  {
    name: "service-basicData-years",
    path: "years",
    meta: index5Wp4lMS26pMeta || {},
    component: () => import("/home/forge/oase-aej.de/releases/81992485/client/pages/service/basicData/years/index.vue")
  }
]
  },
  {
    name: "service-formProcesses-id",
    path: "formProcesses/:id()",
    meta: _91id_93bz8KNoA79IMeta || {},
    component: () => import("/home/forge/oase-aej.de/releases/81992485/client/pages/service/formProcesses/[id].vue")
  },
  {
    name: "service",
    path: "",
    component: () => import("/home/forge/oase-aej.de/releases/81992485/client/pages/service/index.vue")
  },
  {
    name: "service-payments",
    path: "payments",
    meta: payments5VsYy1KCBJMeta || {},
    component: () => import("/home/forge/oase-aej.de/releases/81992485/client/pages/service/payments.vue"),
    children: [
  {
    name: "service-payments-paymentRuns-id",
    path: "paymentRuns/:id()",
    meta: _91id_934SBnW8gLX4Meta || {},
    component: () => import("/home/forge/oase-aej.de/releases/81992485/client/pages/service/payments/paymentRuns/[id].vue"),
    children: [
  {
    name: "service-payments-paymentRuns-id-paymentRunActivities",
    path: "paymentRunActivities",
    component: () => import("/home/forge/oase-aej.de/releases/81992485/client/pages/service/payments/paymentRuns/[id]/paymentRunActivities.vue")
  },
  {
    name: "service-payments-paymentRuns-id-paymentRunBaseData",
    path: "paymentRunBaseData",
    component: () => import("/home/forge/oase-aej.de/releases/81992485/client/pages/service/payments/paymentRuns/[id]/paymentRunBaseData.vue")
  },
  {
    name: "service-payments-paymentRuns-id-paymentRunPayments",
    path: "paymentRunPayments",
    component: () => import("/home/forge/oase-aej.de/releases/81992485/client/pages/service/payments/paymentRuns/[id]/paymentRunPayments.vue")
  }
]
  },
  {
    name: "service-payments-paymentRuns",
    path: "paymentRuns",
    meta: index6hMOLjvZd9Meta || {},
    component: () => import("/home/forge/oase-aej.de/releases/81992485/client/pages/service/payments/paymentRuns/index.vue")
  }
]
  },
  {
    name: "service-processes-id",
    path: "processes/:id()",
    meta: _91id_93wLXkDwCpI6Meta || {},
    component: () => import("/home/forge/oase-aej.de/releases/81992485/client/pages/service/processes/[id].vue"),
    children: [
  {
    name: "service-processes-id-processActivities",
    path: "processActivities",
    component: () => import("/home/forge/oase-aej.de/releases/81992485/client/pages/service/processes/[id]/processActivities.vue")
  },
  {
    name: "service-processes-id-processBaseData",
    path: "processBaseData",
    component: () => import("/home/forge/oase-aej.de/releases/81992485/client/pages/service/processes/[id]/processBaseData.vue")
  }
]
  },
  {
    name: "service-processes",
    path: "processes",
    meta: indexa81fTnixu6Meta || {},
    component: () => import("/home/forge/oase-aej.de/releases/81992485/client/pages/service/processes/index.vue")
  },
  {
    name: "service-processes-massApproval",
    path: "processes/massApproval",
    meta: massApprovalCGFMcYihRaMeta || {},
    component: () => import("/home/forge/oase-aej.de/releases/81992485/client/pages/service/processes/massApproval.vue")
  },
  {
    name: "service-settings",
    path: "settings",
    meta: settingsuC5F9BVtKoMeta || {},
    component: () => import("/home/forge/oase-aej.de/releases/81992485/client/pages/service/settings.vue"),
    children: [
  {
    name: loginProvidersM70QbXmTT8Meta?.name,
    path: "loginProviders",
    meta: loginProvidersM70QbXmTT8Meta || {},
    component: () => import("/home/forge/oase-aej.de/releases/81992485/client/pages/service/settings/loginProviders.vue"),
    children: [
  {
    name: "service-settings-loginProviders-id",
    path: ":id()",
    meta: _91id_93yqONJDo0pGMeta || {},
    component: () => import("/home/forge/oase-aej.de/releases/81992485/client/pages/service/settings/loginProviders/[id].vue")
  },
  {
    name: "service-settings-loginProviders",
    path: "",
    meta: indexZwVeSXtkjgMeta || {},
    component: () => import("/home/forge/oase-aej.de/releases/81992485/client/pages/service/settings/loginProviders/index.vue")
  }
]
  },
  {
    name: organisations1TgKB3DhfIMeta?.name,
    path: "organisations",
    meta: organisations1TgKB3DhfIMeta || {},
    component: () => import("/home/forge/oase-aej.de/releases/81992485/client/pages/service/settings/organisations.vue"),
    children: [
  {
    name: "service-settings-organisations-id",
    path: ":id()",
    meta: _91id_9360oMDLXdVjMeta || {},
    component: () => import("/home/forge/oase-aej.de/releases/81992485/client/pages/service/settings/organisations/[id].vue"),
    children: [
  {
    name: "service-settings-organisations-id-organisationActivities",
    path: "organisationActivities",
    component: () => import("/home/forge/oase-aej.de/releases/81992485/client/pages/service/settings/organisations/[id]/organisationActivities.vue")
  },
  {
    name: "service-settings-organisations-id-organisationAssociationSettings",
    path: "organisationAssociationSettings",
    component: () => import("/home/forge/oase-aej.de/releases/81992485/client/pages/service/settings/organisations/[id]/organisationAssociationSettings.vue")
  },
  {
    name: "service-settings-organisations-id-organisationBaseData",
    path: "organisationBaseData",
    component: () => import("/home/forge/oase-aej.de/releases/81992485/client/pages/service/settings/organisations/[id]/organisationBaseData.vue")
  },
  {
    name: "service-settings-organisations-id-organisationCategories",
    path: "organisationCategories",
    component: () => import("/home/forge/oase-aej.de/releases/81992485/client/pages/service/settings/organisations/[id]/organisationCategories.vue")
  },
  {
    name: "service-settings-organisations-id-organisationProtectionConcept",
    path: "organisationProtectionConcept",
    component: () => import("/home/forge/oase-aej.de/releases/81992485/client/pages/service/settings/organisations/[id]/organisationProtectionConcept.vue")
  },
  {
    name: "service-settings-organisations-id-organisationStemSheet",
    path: "organisationStemSheet",
    component: () => import("/home/forge/oase-aej.de/releases/81992485/client/pages/service/settings/organisations/[id]/organisationStemSheet.vue")
  },
  {
    name: "service-settings-organisations-id-organisationUsers",
    path: "organisationUsers",
    component: () => import("/home/forge/oase-aej.de/releases/81992485/client/pages/service/settings/organisations/[id]/organisationUsers.vue")
  }
]
  },
  {
    name: "service-settings-organisations",
    path: "",
    meta: index7XymXj0lahMeta || {},
    component: () => import("/home/forge/oase-aej.de/releases/81992485/client/pages/service/settings/organisations/index.vue")
  }
]
  },
  {
    name: usersx8z5ak7V4gMeta?.name,
    path: "users",
    meta: usersx8z5ak7V4gMeta || {},
    component: () => import("/home/forge/oase-aej.de/releases/81992485/client/pages/service/settings/users.vue"),
    children: [
  {
    name: "service-settings-users-id",
    path: ":id()",
    meta: _91id_93bp3GGznALIMeta || {},
    component: () => import("/home/forge/oase-aej.de/releases/81992485/client/pages/service/settings/users/[id].vue"),
    children: [
  {
    name: "service-settings-users-id-userActivities",
    path: "userActivities",
    component: () => import("/home/forge/oase-aej.de/releases/81992485/client/pages/service/settings/users/[id]/userActivities.vue")
  },
  {
    name: "service-settings-users-id-userBaseData",
    path: "userBaseData",
    component: () => import("/home/forge/oase-aej.de/releases/81992485/client/pages/service/settings/users/[id]/userBaseData.vue")
  },
  {
    name: "service-settings-users-id-userFilters",
    path: "userFilters",
    component: () => import("/home/forge/oase-aej.de/releases/81992485/client/pages/service/settings/users/[id]/userFilters.vue")
  },
  {
    name: "service-settings-users-id-userSignature",
    path: "userSignature",
    component: () => import("/home/forge/oase-aej.de/releases/81992485/client/pages/service/settings/users/[id]/userSignature.vue")
  }
]
  },
  {
    name: "service-settings-users",
    path: "",
    meta: indexx0JmFkf1wwMeta || {},
    component: () => import("/home/forge/oase-aej.de/releases/81992485/client/pages/service/settings/users/index.vue")
  }
]
  }
]
  }
]
  },
  {
    name: "settings",
    path: "/settings",
    meta: settings4iUyez6raCMeta || {},
    component: () => import("/home/forge/oase-aej.de/releases/81992485/client/pages/settings.vue"),
    children: [
  {
    name: "settings-childOrganisations",
    path: "childOrganisations",
    meta: indexZwSR7NaHVaMeta || {},
    component: () => import("/home/forge/oase-aej.de/releases/81992485/client/pages/settings/childOrganisations/index.vue")
  },
  {
    name: "settings-language",
    path: "language",
    component: () => import("/home/forge/oase-aej.de/releases/81992485/client/pages/settings/language.vue")
  },
  {
    name: "settings-organisations-id",
    path: "organisations/:id()",
    meta: _91id_93un3Sg0B3YbMeta || {},
    component: () => import("/home/forge/oase-aej.de/releases/81992485/client/pages/settings/organisations/[id].vue"),
    children: [
  {
    name: "settings-organisations-id-organisationBaseData",
    path: "organisationBaseData",
    component: () => import("/home/forge/oase-aej.de/releases/81992485/client/pages/settings/organisations/[id]/organisationBaseData.vue")
  },
  {
    name: "settings-organisations-id-organisationCategories",
    path: "organisationCategories",
    component: () => import("/home/forge/oase-aej.de/releases/81992485/client/pages/settings/organisations/[id]/organisationCategories.vue")
  },
  {
    name: "settings-organisations-id-organisationProtectionConcept",
    path: "organisationProtectionConcept",
    component: () => import("/home/forge/oase-aej.de/releases/81992485/client/pages/settings/organisations/[id]/organisationProtectionConcept.vue")
  },
  {
    name: "settings-organisations-id-organisationStemSheet",
    path: "organisationStemSheet",
    component: () => import("/home/forge/oase-aej.de/releases/81992485/client/pages/settings/organisations/[id]/organisationStemSheet.vue")
  },
  {
    name: "settings-organisations-id-organisationUsers",
    path: "organisationUsers",
    component: () => import("/home/forge/oase-aej.de/releases/81992485/client/pages/settings/organisations/[id]/organisationUsers.vue")
  }
]
  },
  {
    name: "settings-users-id",
    path: "users/:id()",
    meta: _91id_937ZDzhbfQmYMeta || {},
    component: () => import("/home/forge/oase-aej.de/releases/81992485/client/pages/settings/users/[id].vue"),
    children: [
  {
    name: "settings-users-id-userBaseData",
    path: "userBaseData",
    component: () => import("/home/forge/oase-aej.de/releases/81992485/client/pages/settings/users/[id]/userBaseData.vue")
  },
  {
    name: "settings-users-id-userSignature",
    path: "userSignature",
    component: () => import("/home/forge/oase-aej.de/releases/81992485/client/pages/settings/users/[id]/userSignature.vue")
  }
]
  }
]
  },
  {
    name: "signature",
    path: "/signature",
    meta: signature8yuDC8QLHlMeta || {},
    component: () => import("/home/forge/oase-aej.de/releases/81992485/client/pages/signature.vue")
  }
]